import React from 'react'
import Navbar from '../components/Navbar'
import ReadAndCompleteComp from '../components/ReadAndCompleteComp'
import Footer from '../components/Footer'

function ReadAndComplete() {
  return (
    <>
    <Navbar />
    <ReadAndCompleteComp />
    <Footer />
    </>
  )
}

export default ReadAndComplete


